module.exports = __webpack_public_path__ + "static/apostpage-f896b9d048cf6e43dd3b2247e29603a6.png";